<span
               [ngClass]="value ? classTrue : classFalse"
               [innerHtml]="value ? textTrue : textFalse">
               </span>